export default __webpack_public_path__ + "static/media/design.f5a6ace1.png";